<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">葡萄牙35万欧基金移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>
        2018年10月，葡萄牙推出移民新政，鼓励和支持投资者以购买35万欧元基金的投资方式申请葡萄牙黄金居留签证。葡萄牙35万欧基金移民，是一种低成本、申请周期短（4-6个月可获签），且更为快捷的移民方式，省去了申请人看房、买房以及房屋维护的一切费用。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ptg/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1.投资至少35万欧元购买公司资本化的投资基金或风险投资基金；</p>
            <p>2.至少有60%投资通过总部设在葡萄牙境内的商业公司实现；</p>
            <p>3.投资期限5+1年起；</p>
            <p>a.主申请人：
              年满18周岁非欧盟国家公民基金持有人；
            </p>
            <p>
              b.附属申请人：
              合法配偶； 未满18周岁的亲生子女及合法领养子女，或者是18~27周岁，未婚、全职在读、经济依附主申请人的子女；
              65周岁以上的双方父母（65周岁以下，在经济上需依赖于主申请人）
            </p>

          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ptg/2.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、现行欧盟移民法案中，门槛低、入籍更快、成本更低的国家。</p>
            <p>2、一人申请三代获批，尽享免费公立教育、医疗，可畅游26个申根国。</p>
            <p>3、无语言要求，无需蹲坐移民监（一年居住7天即可）。</p>
            <p>4、护照含金量高，可免签185个国家（包括美国、加拿大），出行更便利。</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ptg/3.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>咨询及评估</p>
          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
export default {
  name: 'Ptg'
}
</script>

<style scoped>

</style>
